import H from 'constants/httpMethod.const';
import UMSG_TYPE from 'constants/umsg/type.const';
import logger from 'utils/logger.util';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';

const L = logger('beValueDashMetrics'); // eslint-disable-line no-unused-vars

const fromDtoToValueDashMetrics = (dto) => {
  const stats = dto?.results?.stats_last_30_days ?? {};

  return {
    smsRemindersAndConfirmations: stats.sms_reminders_and_confirmations,
    smsReminderCost: stats.sms_reminder_cost,
    smsReminderDacCost: stats.sms_reminder_dac_cost,
    marketingSent: stats.marketing_sent,
    resultBookingsRevenue: stats.result_bookings_revenue,
    pctOnlineBookings: stats.pct_online_bookings,
    ncobValue: stats.ncob_value,
  };
};

export const beValueDashMetricsRead = actionEndpointBe(
  'beValueDashMetricsRead',
  H.get,
  'metrics/v3/valuedash/:salonId/',
  (options) => ({
    ...options,
    inert: true,
    umsg: UMSG_TYPE.global,
    fromDto: fromDtoToValueDashMetrics,
  }),
);
